// extracted by mini-css-extract-plugin
export var lg = "_j7-7";
export var md = "_j7-6";
export var placeholderContainer = "_j7-1";
export var placeholderIcon = "_j7-2";
export var productImage = "_j7-0";
export var sm = "_j7-5";
export var xl = "_j7-8";
export var xs = "_j7-4";
export var xxs = "_j7-3";